import { callFunction } from "./client";

// Tipos batem com o que os Edge Functions realmente devolvem (supabase/functions/auth-login/index.ts
// e auth-change-password/index.ts) — não é o contrato conceitual do blueprint seção 5, que é anterior
// à implementação real da Etapa 2.

export interface SupabaseAuthUser {
  id: string;
  email?: string;
}

/** Sessão do Supabase Auth, repassada como veio de auth-login — usada como está, sem reprocessar. */
export interface SupabaseSession {
  access_token: string;
  refresh_token: string;
  expires_at?: number;
  expires_in?: number;
  token_type: string;
  user: SupabaseAuthUser;
}

export interface LoginResponse {
  session: SupabaseSession;
  /** null para contas técnicas que não possuem registro em public.members. */
  user: { id: string; member_id: string | null };
  requires_password_change: boolean;
  /** Fase F1 (ADR-054): true quando o papel exige TOTP e a sessão ainda não tem fator verificado. */
  requires_mfa_enrollment: boolean;
}

export interface ChangePasswordResponse {
  status: "completed" | "already_completed";
  requires_password_change: false;
}

export function login(username: string, password: string): Promise<LoginResponse> {
  return callFunction<{ username: string; password: string }, LoginResponse>("auth-login", {
    username,
    password,
  });
}

export function changePassword(
  accessToken: string,
  newPassword: string,
  operationId: string,
): Promise<ChangePasswordResponse> {
  return callFunction<{ new_password: string; operation_id: string }, ChangePasswordResponse>(
    "auth-change-password",
    { new_password: newPassword, operation_id: operationId },
    { accessToken },
  );
}
